import React from 'react';
import { View, TouchableWithoutFeedback } from 'react-native';

import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import styles from './ShowMore.Styles.js';

const ShowMore = ({ withShowMore, isShowMoreOpened, onPress }) => {
  const theme = useTheme();

  if (!withShowMore) {
    return null;
  }

  return (
    <>
      {!isShowMoreOpened && <View style={styles.divider(theme)} />}
      <TouchableWithoutFeedback onPress={onPress}>
        <VFText
          i18nKey={isShowMoreOpened ? 'my_device_show_less' : 'my_device_show_more'}
          style={styles.showMoreText(theme)}
        />
      </TouchableWithoutFeedback>
    </>
  );
};

ShowMore.propTypes = {
  withShowMore: PropTypes.bool,
  isShowMoreOpened: PropTypes.bool,
  onPress: PropTypes.func,
};

export default ShowMore;
